
import React, { useRef, useEffect } from "react";
import DBSegmentTable from "../components/DBSegment/DBSegmentTable.js"
import NotificationAlert from "react-notification-alert";

function DBSegment(props) {
    const notificationAlertRef = useRef(null);

    const notify = (place, message, type = 1, autoDismiss = 5) => {

        var options = {};
        options = {
            place: place,
            message: (
                <div>
                    {message}
                </div>
            ),
            type: type,
            icon: "tim-icons icon-bell-55",
            autoDismiss: autoDismiss
        };
        notificationAlertRef.current.notificationAlert(options);
    }

    useEffect(() => {
        document.title = 'DBSegment - TMH Admin';
    })


    return (
        <div className="content">
            <div className="react-notification-alert-container">
                <NotificationAlert ref={notificationAlertRef} />
            </div>

            <DBSegmentTable notify={notify} db_type={1} />
            <DBSegmentTable notify={notify} db_type={2} />
            <DBSegmentTable notify={notify} db_type={3} />
        </div>
    );
}
export default DBSegment;
